<form [formGroup]="requestForm()">
    @if (isTransfer()) {
    <div class="row g-3">
        <div class="col-12">
            <label class="form-label fw-bold small text-uppercase text-muted">Entidad Destino</label>
            <app-sheet-select
                [items]="entities"
                bindLabel="name"
                bindValue="code"
                title="Entidad Destino"
                placeholder="Seleccione Entidad Destino"
                formControlName="targetEntityCode"
                [clearable]="false"
                [searchable]="entities.length > 5">
            </app-sheet-select>
        </div>
    </div>
    }
</form>
